// extracted by mini-css-extract-plugin
export default {"button":"styles_button__ug3D3","leftCircle":"styles_leftCircle__+TQ02","circle":"styles_circle__fCE4T","buttonText":"styles_buttonText__kGCPN"};